<template>
  <div
    ref="root"
    class="contents-insurance-tooltip tw-relative tw-hidden tw-rounded-[16px] tw-shadow-lg md:tw-block"
  >
    <div
      class="insurance-banner insurance-banner--filled-corner tw-relative tw-flex tw-h-full tw-w-full tw-overflow-hidden tw-rounded-[16px] tw-border-0 tw-p-[18px] tw-shadow-lg"
    >
      <div class="insurance-banner__panel" aria-hidden="true"></div>
      <div class="tw-relative tw-z-[1] tw-w-full">
        <p
          class="tw-font-inter tw-mb-0 tw-w-full tw-text-left tw-text-[26px] tw-font-normal tw-leading-[32px] tw-text-white min-[1343px]:tw-text-[22px] min-[1343px]:tw-leading-[33px]"
        >
          <span class="tw-font-bold">FREE Contents</span><br />
          <span class="tw-font-bold">Insurance</span> included with every UniHomes utilities package
          <button
            ref="toggle"
            type="button"
            class="tw-inline-flex tw-h-[20px] tw-w-[20px] tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-align-middle"
            aria-label="Show contents insurance information"
            :aria-expanded="showTooltip ? 'true' : 'false'"
            @click.stop="toggleTooltip"
          >
            <img
              :src="cdnAsset('svg/uh-info-icon-white.svg')"
              alt=""
              class="tw-h-[20px] tw-w-[20px]"
              aria-hidden="true"
            />
          </button>
        </p>
      </div>

      <div
        class="tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-h-full tw-w-[176px] tw-overflow-visible md:tw-w-full"
      >
        <div
          class="insurance-banner__art-shell tw-absolute tw-bottom-[-94px] tw-right-[-92px] tw-h-[352px] tw-w-[352px] min-[1343px]:tw-bottom-[-80px] min-[1343px]:tw-right-[-78px] min-[1343px]:tw-h-[300px] min-[1343px]:tw-w-[300px]"
        >
          <div class="tw-relative tw-h-full tw-w-full">
            <span
              class="free-badge tw-absolute tw-left-0 tw-top-[30px] tw-z-[2] tw-inline-flex tw-items-center tw-justify-center tw-rounded-[30px] tw-px-[20px] tw-py-[10px] tw-text-[34px] tw-font-[800] tw-leading-[50px] tw-text-white tw-shadow-[8px_8px_0_0_rgba(0,0,0,0.25)] min-[1343px]:tw-rounded-[24px] min-[1343px]:tw-px-[16px] min-[1343px]:tw-py-[8px] min-[1343px]:tw-text-[28px] min-[1343px]:tw-leading-[40px]"
            >
              FREE
            </span>
            <div
              class="insurance-banner__halo tw-absolute tw-inset-0 tw-rounded-full"
            ></div>
            <div
              class="insurance-banner__circle tw-absolute tw-bottom-[44px] tw-right-[44px] tw-flex tw-h-[265px] tw-w-[265px] min-[1343px]:tw-bottom-[38px] min-[1343px]:tw-right-[38px] min-[1343px]:tw-h-[225px] min-[1343px]:tw-w-[225px] tw-items-center tw-justify-center tw-rounded-full"
            >
              <img
                :src="cdnAsset('svg/uh-shield-check-icon-clean.svg')"
                alt="Contents insurance shield"
                class="insurance-banner__shield tw-h-auto tw-w-[130px] min-[1343px]:tw-w-[110px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="showTooltip"
      ref="panel"
      class="tw-absolute tw-z-[10]"
      :style="tooltipStyle"
    >
      <div
        class="tw-relative tw-rounded-[8px] tw-bg-[#3B4143] tw-p-[8px] tw-shadow-[0_4px_24px_0_rgba(0,0,0,0.40)]"
      >
        <p
          class="tw-font-inter tw-mb-0 tw-text-left tw-text-[16px] tw-font-[400] tw-leading-[24px] tw-text-white"
        >
          Provided alongside your UniHomes utilities package at no additional
          cost to you.
        </p>
        <span
          class="tw-absolute tw-bottom-[-6px] tw-h-[12px] tw-w-[12px] -tw-translate-x-1/2 tw-rotate-45 tw-bg-[#3B4143]"
          :style="{ left: 'var(--contents-insurance-tooltip-arrow-left, 50%)' }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentsInsurancePromoDesktopTile',
  props: {
    cityName: {
      default: 'this city',
      type: String,
    },
  },
  data() {
    return {
      showTooltip: false,
      tooltipStyle: {},
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleEscapeKey);
    window.addEventListener('resize', this.updateTooltipPosition);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleEscapeKey);
    window.removeEventListener('resize', this.updateTooltipPosition);
  },
  methods: {
    closeTooltip() {
      this.showTooltip = false;
    },
    handleDocumentClick(event) {
      if (!this.showTooltip) {
        return;
      }

      if (!this.$refs.root?.contains(event.target)) {
        this.closeTooltip();
      }
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.closeTooltip();
      }
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;

      if (this.showTooltip) {
        this.$nextTick(this.updateTooltipPosition);
      }
    },
    updateTooltipPosition() {
      if (
        !this.showTooltip ||
        !this.$refs.root ||
        !this.$refs.toggle ||
        !this.$refs.panel
      ) {
        return;
      }

      const rootRect = this.$refs.root.getBoundingClientRect();
      const toggleRect = this.$refs.toggle.getBoundingClientRect();
      const panel = this.$refs.panel;
      const horizontalGutter = 24;
      const tooltipGap = 12;
      const arrowPadding = 32;
      const targetWidth = Math.min(
        400,
        Math.max(window.innerWidth - horizontalGutter * 2, 0)
      );

      panel.style.width = `${targetWidth}px`;
      const panelRect = panel.getBoundingClientRect();
      const toggleCenter = toggleRect.left + toggleRect.width / 2;
      const panelLeft = Math.min(
        Math.max(toggleCenter - panelRect.width / 2, horizontalGutter),
        Math.max(
          horizontalGutter,
          window.innerWidth - panelRect.width - horizontalGutter
        )
      );
      const panelTop =
        toggleRect.top - rootRect.top - panelRect.height - tooltipGap;
      const arrowLeft = Math.min(
        Math.max(toggleCenter - panelLeft, arrowPadding),
        panelRect.width - arrowPadding
      );

      this.tooltipStyle = {
        '--contents-insurance-tooltip-arrow-left': `${arrowLeft}px`,
        left: `${panelLeft - rootRect.left}px`,
        top: `${panelTop}px`,
        width: `${targetWidth}px`,
      };
    },
  },
};
</script>
